import { DisplayMarket, DisplayMarketAsset } from "@silo/types";
import { cn } from "../../utils/class-names";
import { isNotNullable } from "effect/Predicate";
import { ReactNode } from "react";
import { TokenContext } from "../token-context";
import { asCompactUsd } from "@silo/utils";

interface AvailableToBorrowProps {
  className?: string;
  market: DisplayMarket;
  tokenLogo: ReactNode;
}

export function AvailableToBorrow({
  className,
  market,
  tokenLogo,
}: AvailableToBorrowProps): JSX.Element {
  const {
    baseAsset,
    bridgeAssets: [firstBridgeAsset, secondBridgeAsset],
  } = market;

  const showBase =
    baseAsset.liquidityUsd > 0n || baseAsset.depositMode !== "protectedOnly";

  const showSecondBridge = isNotNullable(secondBridgeAsset);

  return (
    <div className={cn("flex flex-col gap-4", className)}>
      <p className="text-xs font-normal text-shale-200">Available to borrow</p>

      <div className="flex items-center gap-4 font-mono text-white">
        {showBase && <AssetLiquidity asset={baseAsset} tokenLogo={tokenLogo} />}

        <AssetLiquidity asset={firstBridgeAsset} tokenLogo={tokenLogo} />

        {showSecondBridge && (
          <AssetLiquidity asset={secondBridgeAsset} tokenLogo={tokenLogo} />
        )}
      </div>
    </div>
  );
}

interface AssetLiquidityProps {
  asset: DisplayMarketAsset;
  tokenLogo: ReactNode;
}

function AssetLiquidity({
  asset,
  tokenLogo,
}: AssetLiquidityProps): JSX.Element {
  const { chainKey, tokenAddress, liquidityUsd } = asset;

  return (
    <div className="flex items-center gap-1 text-sm font-medium">
      <TokenContext.Provider value={{ chainKey, tokenAddress }}>
        {tokenLogo}
      </TokenContext.Provider>

      <div>{asCompactUsd(liquidityUsd)}</div>
    </div>
  );
}
